import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Stethoscope } from "lucide-react";
import spApi, { spErrorMessage, setSpToken } from "@/lib/spApi";

const input = "w-full bg-[#111111] border border-[#333333] rounded-xl px-4 py-3.5 min-h-[44px] text-[#F8FAFC] placeholder:text-[#666666] focus:outline-none focus:border-[#EF9F27]";

export default function SpecialistLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await spApi.post("/specialists/login", { email, password });
      setSpToken(data.token);
      const st = data.specialist.verification_status;
      navigate(st === "verified" ? "/specialist/portal" : "/specialist/status", { replace: true });
    } catch (e) {
      toast.error(spErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="care-scope min-h-screen w-full flex justify-center bg-black">
      <div className="relative w-full max-w-[430px] min-h-screen bg-[#111111] flex flex-col justify-center px-6">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-[#EF9F27] text-[#111111] mb-4">
          <Stethoscope size={24} />
        </div>
        <h1 className="font-head text-2xl font-extrabold text-[#F8FAFC]">Specialist sign in</h1>
        <p className="text-sm text-[#A1A1AA] mt-1 mb-5">Access your application status and case portal.</p>
        <input data-testid="sp-login-email" className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="sp-login-password" className={`${input} mt-3`} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} />
        <button data-testid="sp-login-submit" onClick={submit} disabled={busy || !email || !password}
          className="mt-5 w-full rounded-full bg-[#EF9F27] text-[#111111] font-bold px-6 py-3.5 min-h-[48px] disabled:opacity-50">
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p className="text-center text-sm text-[#A1A1AA] mt-6">
          New specialist?{" "}
          <button data-testid="sp-goto-signup" onClick={() => navigate("/specialist/signup")} className="font-bold text-[#EF9F27]">Apply to join</button>
        </p>
      </div>
    </div>
  );
}
